module.exports = __webpack_public_path__ + "static/media/flag_icon_success.9fdcf9a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/flag_icon_success.svg
// module id = 308
// module chunks = 2